export interface INominationType {
  isCivilian: boolean
  isMilitary: boolean
  name: string
}
